import styled from 'styled-components';

const ProfileContainer = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export {
  ProfileContainer
}